// extracted by mini-css-extract-plugin
export default {"homeservices":"HomeServices_homeservices__R6CjE","certificados_group":"HomeServices_certificados_group__j08s0","certificados_card":"HomeServices_certificados_card__Zc+f8"};